import {createColumn, defaultColumns, inputTextField, relationField} from '../_defaults/columns'
import {dateFormat} from '../../plugins/filters'

export const columns = [
  createColumn({
    label: 'Status',
    field: 'status',
    // type: 'text',
    section: 'Basic Info',
    component: {
      is: 'q-select',
      props: {
        options: [
          {
            label: 'PENDING',
            value: 'PENDING'
          },
          {
            label: 'SUCCEEDED',
            value: 'SUCCEEDED'
          },
          {
            label: 'DECLINED',
            value: 'DECLINED'
          },
          {
            label: 'VOIDED',
            value: 'VOIDED'
          },
          {
            label: 'REFUNDED',
            value: 'REFUNDED'
          }
        ]
      }
    }
  }),
  createColumn({
    label: 'Amount',
    field: 'amount',
    type: 'number',
    section: 'Basic Info',
    component: inputTextField({ req: false, type: 'number', money: true })
  }),
  createColumn({
    label: 'Date',
    field: 'date',
    type: 'date',
    section: 'Basic Info',
    displayValue: row => {
      return row.date ? dateFormat(row.date, 'MMM DD YYYY - h:mm a') : 'N/A'
    },
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: true
      }
    }
  }),
  createColumn({
    label: 'Type',
    field: 'purchaseType',
    section: 'Related Info',
    ...relationField({
      validation: { required: false },
      type: 'one',
      localKey: 'purchaseTypeId',
      // fk: 'id',
      // localKey: 'id',
      // fk: 'purchaseTypeId',
      namespace: 'purchaseType',
      filterIs: 'select-one-field',
      label: 'description',
      // filterIs: 'text-filter',
      props: { addButton: false, allowEdit: false }
    })
  }),
  createColumn({
    label: 'Fund Account Type',
    field: 'fundAccountType',
    section: 'Related Info',
    // displayValue: row => `${row.fundAccountType.description}`.trim(),
    ...relationField({
      type: 'one',
      localKey: 'fundAccountTypeId',
      // localKey: 'id',
      // fk: 'fundAccountTypeId',
      namespace: 'fundAccountType',
      filterIs: 'select-one-field',
      label: 'description',
      props: { addButton: false, allowEdit: false }
    })
  }),
  // createColumn({
  //   label: 'Person',
  //   field: 'person',
  //   ...relationField({
  //     validation: { required: false },
  //     type: 'one',
  //     localKey: 'personId',
  //     // localKey: 'id',
  //     // fk: 'personId',
  //     namespace: 'person',
  //     filterIs: 'text-filter'
  //   })
  // }),
  createColumn({
    label: 'Person',
    field: 'person',
    section: 'Related Info',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      validation: { required: false },
      namespace: 'person',
      filterIs: 'text-filter',
      // saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      localKey: 'personId'
    })
  }),
  createColumn({
    label: 'Event',
    field: 'event',
    section: 'Related Info',
    // description: 'Listing of all users who have access to modify this school'
    // displayValue: row => `${row.event.name}`.trim(),
    ...relationField({
      validation: { required: false },
      type: 'one',
      localKey: 'eventId',
      // localKey: 'id',
      // fk: 'eventId',
      namespace: 'event',
      props: { addButton: false, allowEdit: false }
    })
  }),
  createColumn({
    label: 'Contract',
    field: 'purchaseContract',
    filterIs: 'select-one-field',
    section: 'Related Info',
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'purchase',
      localKey: 'id',
      namespace: 'contract',
      label: 'name',
      filterIs: 'select-many-field',
      directSearch: 'purchaseCompany/contractId',
      fieldType: 'number',
      parentRestraint: true,
      props: { allowEdit: false }
    })
  }),
  createColumn({
    label: 'Address',
    field: 'address',
    section: 'Related Info',
    // description: 'Listing of all users who have access to modify this school'
    // displayValue: row => `${row.event.name}`.trim(),
    ...relationField({
      validation: { required: false },
      type: 'one',
      localKey: 'addressId',
      // localKey: 'id',
      // fk: 'eventId',
      namespace: 'address'
      // props: { addButton: false, allowEdit: false }
    })
  }),
  createColumn({
    label: 'Comment',
    visible: true,
    field: 'comment',
    section: 'Basic Info',
    component: inputTextField({ type: 'textarea', req: false, max: 8192 })
  }),
  createColumn({
    label: 'Quickbooks Invoice ID',
    isTitle: true,
    field: 'qbInvoiceId',
    section: 'QuickBooks',
    component: {
      is: 'quickbooks-invoice'
    }
    // component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'Quickbooks Sales Receipt ID',
    field: 'qbSalesReceiptId',
    section: 'QuickBooks',
    component: {
      is: 'quickbooks-sales-receipt'
    }
    // component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'Quickbooks Customer ID',
    field: 'qbCustomerId',
    section: 'QuickBooks',
    component: {
      is: 'quickbooks-customer'
    }
    // component: inputTextField({ req: false, max: 255 })
  })
  // createColumn({
  //   label: 'Quickbooks Transaction ID',
  //   field: 'qbTransactionId',
  //   component: inputTextField({ req: false, max: 255 })
  // }),
  // createColumn({
  //   label: 'Discount',
  //   field: 'eventDiscount',
  //   ...relationField({
  //     type: 'one',
  //     label: 'description',
  //     namespace: 'eventDiscount',
  //     filterIs: 'text-filter'
  //   })
  // }),
  // createColumn({
  //   label: 'Sponsorship',
  //   field: 'sponsorship',
  //   ...relationField({
  //     type: 'one',
  //     label: 'lastName',
  //     namespace: 'name',
  //     filterIs: 'text-filter'
  //   })
  // })
].concat(defaultColumns)
